enum FieldIdentifier {
  CAPTCHA_TEXT = "challengeText",
  CAPTCHA_ID = "id",
  ORGANIZATION_ID = "organizationId",
  BULK_TICKET_QUANTITY = "numberOfTicketsToPurchase",
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  ORGANIZATION_NAME = "organizationName",
  ORGANIZATION_URL = "organizationUrl",
  JOB_TITLE = "jobTitle",
  ORGANIZATION_DESCRIPTION = "organizationDescription",
  TABLETALK_BIOGRAPHY = "biography"
}

export default FieldIdentifier;

export const ActivityPrioritisationStaticFieldsIdentifier = [
  FieldIdentifier.FIRST_NAME,
  FieldIdentifier.LAST_NAME,
  FieldIdentifier.ORGANIZATION_NAME,
  FieldIdentifier.JOB_TITLE
];
